import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading text-background-50">
                {siteConfig.name}
              </span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed max-w-sm">
              福利视频导为您汇聚全网优质视频内容，精准分类导航，一站式发现热门福利视频资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">首页</Link>
              <Link to="/category" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">视频分类</Link>
              <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/entertainment" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">娱乐视频</Link>
              <Link to="/category/education" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">学习教育</Link>
              <Link to="/category/tech" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">科技数码</Link>
              <Link to="/category/food" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">美食烹饪</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <p className="text-xs text-secondary-400">
            {siteConfig.name} - 精选内容聚合平台
          </p>
        </div>
      </div>
    </footer>
  );
}